import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import Chart from '../Charts/Chart.vue';
import { isEmpty } from '@/utils/misc';
import ValueTrend from '@/components/common/ValueTrend.vue';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import { abbreviateNumber } from '@/utils/number';
import KpiWidgetTrendTooltip from '@/components/common/KpiWidgetTrendTooltip.vue';
import { TrendData } from '@/components/bend/kpiWidgetUtils';
import { computed } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'KpiWidget',
  props: {
    chartData: null,
    trendData: null,
    generator: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean },
    trendTooltipPosition: { default: 'is-top' },
    invertTrend: { type: Boolean, default: false },
    mainFactFormatter: { type: Function, default: abbreviateNumber },
    tooltipValueFormatter: null
  },
  setup(__props: any) {

const props = __props as { chartData: any | null, trendData: TrendData | null, generator: ChartGenerator<any>, widgetDefinition: WidgetDefinition, loading: boolean, isFetchingForTheFirstTime: boolean, trendTooltipPosition: 'is-top' | 'is-bottom' | 'is-left' | 'is-right', invertTrend: boolean, mainFactFormatter: (n: number) => string, tooltipValueFormatter?: (n: number) => string };



const formattedMainFact = computed<string>(() =>
  props.mainFactFormatter(props.trendData!.currentValue),
);

const hasData = computed<boolean>(() => !isEmpty(props.chartData));

const isThereTrendInfo = computed<boolean>(
  () => props.trendData?.previousValue !== 0,
);

const { t } = useI18n();

return { __sfc: true,props, formattedMainFact, hasData, isThereTrendInfo, t, Chart, ValueTrend, KpiWidgetTrendTooltip }
}

})